<div class="alert" [ngClass]="severity" *ngIf="!hidden">
  <span class="ico" aria-hidden="true">{{ icon }}</span>
  <div class="body">
    <strong *ngIf="title">{{ title }}</strong>
    <ng-content></ng-content>
  </div>
  <span class="close" *ngIf="closable" (click)="onClose($event)" aria-label="Dismiss">×</span>
</div>
